import { SearchResponse } from 'types/search';
import searchApi from '@lib/api-fetch/search-api';
import { getLogger } from '@lib/util/logging-util';

export async function getSearchHandle(
    location: string,
    term?: string | null,
    category?: string | string[] | null,
    limit: number = 10,
    offset: number = 0,
    sort_by: string = 'best_match',
    enableSearch: boolean = true,
    providerId: string = 'yelp',
    pageToken: string = '',
    queryAsObject: any = null,
    isSearchTop: boolean = false
): Promise<SearchResponse> {
    const searchId = `search-handle-${Date.now()}`;
    const logger = getLogger();

    logger.verbose(`[getSearchHandle][${searchId}] ========== START ==========`);
    logger.verbose(`[getSearchHandle][${searchId}] Input parameters:`);
    logger.verbose(`[getSearchHandle][${searchId}]   location: ${location}`);
    logger.verbose(`[getSearchHandle][${searchId}]   term: ${term}`);
    logger.verbose(`[getSearchHandle][${searchId}]   category: ${JSON.stringify(category)}`);
    logger.verbose(`[getSearchHandle][${searchId}]   limit: ${limit}`);
    logger.verbose(`[getSearchHandle][${searchId}]   offset: ${offset}`);
    logger.verbose(`[getSearchHandle][${searchId}]   sort_by: ${sort_by}`);
    logger.verbose(`[getSearchHandle][${searchId}]   enableSearch: ${enableSearch}`);
    logger.verbose(`[getSearchHandle][${searchId}]   providerId: ${providerId}`);
    logger.verbose(`[getSearchHandle][${searchId}]   pageToken: ${pageToken}`);
    logger.verbose(`[getSearchHandle][${searchId}]   queryAsObject: ${JSON.stringify(queryAsObject)}`);
    logger.verbose(`[getSearchHandle][${searchId}]   isSearchTop: ${isSearchTop}`);

    if (enableSearch === false) {
        logger.verbose(`[getSearchHandle][${searchId}] Search disabled, returning empty response`);
        return {
            businesses: [],
            total: 0,
            region: {
                center: {
                    longitude: 0,
                    latitude: 0,
                },
            },
            error: {
                code: '',
                description: '',
            },
        };
    }

    const card_program =
        category && typeof category === 'object'
            ? category.join(';')
            : category;

    logger.verbose(`[getSearchHandle][${searchId}] Transformed card_program: ${card_program}`);

    const queryParams = {
        limit,
        offset,
        location,
        cardPrograms: card_program ?? '',
        searchTerm: term,
        sortBy: sort_by,
        providerId,
        pageToken,
        isSearchTop,
        ...queryAsObject
    };

    logger.verbose(`[getSearchHandle][${searchId}] Final query parameters:`, JSON.stringify(queryParams, null, 2));

    try {
        const response = await searchApi('GET', '/v2/businesses/search', {
            query: queryParams,
        });

        logger.verbose(`[getSearchHandle][${searchId}] Response received successfully`);
        logger.verbose(`[getSearchHandle][${searchId}] Businesses: ${response.body?.businesses?.length || 0}`);
        logger.verbose(`[getSearchHandle][${searchId}] Total: ${response.body?.total}`);
        logger.verbose(`[getSearchHandle][${searchId}] ========== END ==========`);

        return response.body;
    } catch (err) {
        logger.error(`[getSearchHandle][${searchId}] ========== ERROR ==========`);
        logger.error(`[getSearchHandle][${searchId}] Error:`, err);
        logger.error(`[getSearchHandle][${searchId}] Query params:`, JSON.stringify(queryParams, null, 2));
        logger.error(`[getSearchHandle][${searchId}] ========== END ==========`);
        throw err;
    }
}
